import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { MultiSelectOption } from 'src/app/_shared/interface/multi-select.interface';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import constants from 'src/constant.json';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';
interface activeUserList {
  name: string;
  email: string;
  phoneNumber: number;
  totalReportsCreated: string;
  valueTestReports: string;
  compCheckReports: string;
  smartResearchReports: string;
}
@Component({
  selector: 'app-active-users',
  templateUrl: './active-users.component.html',
  styleUrls: ['./active-users.component.scss']
})
export class ActiveUsersComponent implements OnInit {
  JSON = JSON;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('inviteInvestorDialog', { static: true }) inviteInvestorDialog: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('clientListContainer') clientListContainer: ElementRef;

  @Output() optionEvent = new EventEmitter();
  @Output() setDeafultFilter = new EventEmitter();

  @Input() filterToApply;
  constant: any = constants;
  investorUsersCount: number;
  agentIdList: Array<any>;
  clientNameList: Array<any>;
  canViewLoanOfficer: boolean;
  userFilterForm: FormGroup = this.formBuilder.group({
    name:'',
    duration: ['12', Validators.pattern('[0-9]*')],
    durationType: ['months'],
    userType: ['all'],
    reportType: ['all'],
  });
  userRoles =
  {
    agent:'Agent',
    loanOfficer:'LoanOfficer'
  }
  activeUserFetchParams = {orderBy: '', orderType:'',limit: 10, offset: 0};
  dialogRef: any;
  isDataLoading: boolean = false;
  isDisableFilterBtn = false;
  isDisableResetBtn = false;
  partnershipDetails = [];
  tableDataSource = new MatTableDataSource<activeUserList>([]);
  tableColumnList: string[] = [
    'name',
    'email',
    'phoneNumber',
    'totalReportsCreated',
    'valueTestReports',
    'compCheckReports',
    'smartResearchReports',
  ];
  emailVerificationDate: any;
  verificationStatus: any;
  requestData: { limit: number; offset: number; orderBy: string; orderType: string; filter: any } = {
    limit: this.activeUserFetchParams.limit,
    offset: this.activeUserFetchParams.offset,
    orderBy: this.activeUserFetchParams.orderBy,
    orderType: this.activeUserFetchParams.orderType,
    filter: {},
  };
  userRole: string;
  singleSelectEvent?: any;
  isClientFormValid: boolean = true;
  reset = [];
  optionLength: number;
  selectedDurationType?: any;
  selectDuration: any;
  selectedVerificationStatus: any;
  user: any;
  pageSize: any;
  pageIndex: number;
  companyStatus: boolean = false;
  loginState: boolean = false;
  isTrailPlan: boolean;
  multiSelectOptions: MultiSelectOption[] = [];
  selectedOptions: Array<string>;
  exportingInProgress: boolean = false;
  leadFilter: any[];
  // Subscription to unsubscribe on component destroy
  onDestroyNotifier$ = new Subject();
  isHourDurationValid: boolean = true;
  isMinuteDurationValid: boolean = true;
  inputValue: any = 12;
  pattern = /^[0-9]+$/;
  filterFlag: boolean = false;
  oldDurationValue: any;
  oldDurationTypeValue: any;
  fetchData: boolean = false;
  email: any;
  investorParamsId: any;
  paginationInfo: any;
  activeUsersCount: number;
  hideCompCheck: boolean = false;
  hideSmartResearch: boolean = false;
  hideValueTest: boolean = false;

  constructor(
    private clientDashboardService: ClientDashboardService,
    public clientDashboardState: ClientDashboardState,
    private dialog: MatDialog,
    public formBuilder: FormBuilder,
    public authorizeService: AuthorizeService,
    private userState: UserState,
    public appState: AppState,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.fetchData = true;
      }
    });
    if (this.fetchData) {
      this.fetchInvestorUsers();
    }
    this.clientDashboardState.activeUserList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((activeUsers: any) => {
      this.tableDataSource = new MatTableDataSource(activeUsers.data);
    });
    this.clientDashboardState.activeUserCount$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((count) => {
      this.activeUsersCount = count;
    });
  }

  fetchInvestorUsers() {
    let requestData: any = {
      limit: this.activeUserFetchParams.limit,
      offset: this.activeUserFetchParams.offset,
      orderBy: this.activeUserFetchParams.orderBy,
      orderType: this.activeUserFetchParams.orderType,
      filter: {},
      format:'json'
    };
    this.oldDurationValue = this.userFilterForm.controls.duration.value;
    this.oldDurationTypeValue = this.userFilterForm.controls.durationType.value;
    if (this.oldDurationValue && this.oldDurationTypeValue) {
      requestData.filter.createdDate = moment().subtract(this.oldDurationValue, this.oldDurationTypeValue).toDate();
    } else if (this.filterFlag && this.filterDurationCtrl.value && this.filterDurationTypeCtrl.value) {
      requestData.filter.createdDate = moment()
        .subtract(this.filterDurationCtrl.value, this.filterDurationTypeCtrl.value)
        .toDate();
    } else {
      delete requestData.filter.createdDate;
    }
    if(this.userFilterForm.value.name){
      requestData.filter.name = this.userFilterForm.value.name
    }
    if(this.userFilterForm.value.userType){
      requestData.filter.userType = this.userFilterForm.value.userType
    }
    if(this.userFilterForm.value.reportType ){
      requestData.filter.reportType = this.userFilterForm.value.reportType
      if(this.userFilterForm.value.reportType == 'valueTest') {
        this.hideCompCheck = true;
        this.hideSmartResearch = true;
        this.hideValueTest = false;
        this.removeColumn('compCheckReports')
        this.removeColumn('smartResearchReports')
        this.addColumn('valueTestReports')
      } else if(this.userFilterForm.value.reportType == 'compCheck') {
        this.hideValueTest = true;
        this.hideSmartResearch = true;
        this.hideCompCheck = false;
        this.removeColumn('valueTestReports')
        this.removeColumn('smartResearchReports')
        this.addColumn('compCheckReports')
      } else if (this.userFilterForm.value.reportType == 'smartResearch') {
        this.hideCompCheck = true;
        this.hideValueTest = true;
        this.hideSmartResearch = false;
        this.removeColumn('valueTestReports')
        this.removeColumn('compCheckReports')
        this.addColumn('smartResearchReports')
      } else {
        this.hideCompCheck = false;
        this.hideValueTest = false;
        this.hideSmartResearch = false;
        this.addColumn('smartResearchReports')
        this.addColumn('compCheckReports')
        this.addColumn('valueTestReports')
      }
    }
    if (!Object.keys(requestData.filter).length) {
      delete requestData.filter;
    }
    this.clientDashboardService
      .fetchAllActiveUsers(requestData)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }

  removeColumn(columnName: string) {
    const index = this.tableColumnList.indexOf(columnName);
    if (index >= 0) {
      this.tableColumnList.splice(index, 1); 
    }
  }
  addColumn(columnName: string) {
    const index = this.tableColumnList.indexOf(columnName);
    if (index == -1) {
      this.tableColumnList.push(columnName); 
    }
  }

  sortTable(sortState: Sort) {
    this.paginator.pageIndex = 0;
    this.activeUserFetchParams.limit = 10;
    this.activeUserFetchParams.offset = 0;
    this.activeUserFetchParams.orderBy = sortState.active;
    this.activeUserFetchParams.orderType = sortState.direction;
    this.fetchInvestorUsers();
  }

  pageChange(event) {
    if (this.activeUserFetchParams.offset != event.pageSize * event.pageIndex) {
      this.activeUserFetchParams.limit = event.pageSize;
      this.activeUserFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.activeUserFetchParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.activeUserFetchParams.offset = 0;
    }
    this.fetchInvestorUsers();
    this.clientListContainer.nativeElement.scrollTop = 0;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  openInviteDialogBox() {
    this.dialogRef = this.dialog.open(this.inviteInvestorDialog);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  resetFilter() {
    this.filterFlag = false;
    this.selectedOptions = null;
    this.userFilterForm?.get('durationType').setValue('month');
    this.userFilterForm?.get('duration').setValue('12');
    this.userFilterForm?.get('reportType').setValue('all');
    this.userFilterForm?.get('userType').setValue('all');
    this.userFilterForm?.get('name').setValue('');
    this.activeUserFetchParams.limit = 10;
    this.activeUserFetchParams.offset = 0;
    this.activeUserFetchParams.orderBy = '';
    this.activeUserFetchParams.orderType = '';
    this.paginator.pageSize = 10;
    this.paginator.pageIndex = 0;
    this.fetchInvestorUsers();
  }

  filterData() {
    this.filterFlag = true;
    this.paginator.pageIndex = 0;
    this.activeUserFetchParams.limit = 10;
    this.activeUserFetchParams.offset = 0;
    this.fetchInvestorUsers();
  }

  readyToExport() {
    this.exportingInProgress = true;
    let requestData: any = {
      orderBy: this.activeUserFetchParams.orderBy,
      orderType: this.activeUserFetchParams.orderType,
      filter: {},
      searchClients: this.userFilterForm.value.searchClients,
      format:'csv'
    };
    if (this.oldDurationValue && this.oldDurationTypeValue) {
      requestData.filter.createdDate = moment().subtract(this.oldDurationValue, this.oldDurationTypeValue).toDate();
    } else if (this.filterFlag && this.filterDurationCtrl.value && this.filterDurationTypeCtrl.value) {
      requestData.filter.createdDate = moment()
        .subtract(this.filterDurationCtrl.value, this.filterDurationTypeCtrl.value)
        .toDate();
    } else {
      delete requestData.filter.createdDate;
    }
    requestData.filter.name = this.userFilterForm.value.name
    requestData.filter.userType = this.userFilterForm.value.userType
    requestData.filter.reportType = this.userFilterForm.value.reportType
    if (!Object.keys(requestData.filter).length) {
      delete requestData.filter;
    }
    this.clientDashboardService
    .fetchAllActiveUsers(requestData)
    .pipe(takeUntil(this.onDestroyNotifier$))
    .subscribe((res: any) => {
        if (res && res.data) {
          let delimitedText = res.data.data.userList;
          let durationType = this.oldDurationValue === 1 ? this.oldDurationTypeValue.slice(0, -1) : this.oldDurationTypeValue;
          let csvName = 'userList_' + this.oldDurationValue + '_' + durationType + '.csv';
          let csvData = new Blob([delimitedText], {
            type: 'text/csv;charset=utf-8;',
          });
          let csvURL = window.URL.createObjectURL(csvData);
          let downloadFile = document.createElement('a');
          downloadFile.href = csvURL;
          downloadFile.setAttribute('download', csvName);
          downloadFile.click();
          this.exportingInProgress = false;
        }
    });
  }

  onDurationTypeChange() {
    const durationControl = this.userFilterForm.get('duration');
    const durationTypeControl = this.userFilterForm.get('durationType');

    if (durationTypeControl.value === 'hours') {
      const durationValue = durationControl.value;
      if (durationValue < 1 || durationValue > 24) {
        this.isHourDurationValid = false;
      } else {
        this.isHourDurationValid = true;
      }
    } else if (durationTypeControl.value === 'minutes') {
      const durationValue = durationControl.value;
      if (durationValue < 1 || durationValue > 59) {
        this.isMinuteDurationValid = false;
      } else {
        this.isMinuteDurationValid = true;
      }
    } else if (!this.pattern.test(this.userFilterForm.get('duration').value)) {
      this.isHourDurationValid = false;
      this.isMinuteDurationValid = false;
    } else {
      this.isHourDurationValid = true;
      this.isMinuteDurationValid = true;
    }
    durationControl.updateValueAndValidity();
  }

  onInputChange() {
    if (this.userFilterForm.get('durationType').value == 'hours') {
      if (this.inputValue >= 1 && this.inputValue <= 24) {
        this.isHourDurationValid = true;
      } else {
        this.isHourDurationValid = false;
      }
    } else if (this.userFilterForm.get('durationType').value == 'minutes') {
      if (this.inputValue >= 1 && this.inputValue <= 59) {
        this.isMinuteDurationValid = true;
      } else {
        this.isMinuteDurationValid = false;
      }
    } else if (!this.pattern.test(this.userFilterForm.get('duration').value)) {
      this.isHourDurationValid = false;
      this.isMinuteDurationValid = false;
    } else {
      this.isHourDurationValid = true;
      this.isMinuteDurationValid = true;
    }
  }

  public get filterDurationCtrl(): FormControl {
    return this.userFilterForm.controls.duration as FormControl;
  }

  public get filterDurationTypeCtrl(): FormControl {
    return this.userFilterForm.controls.durationType as FormControl;
  }
}
